import { InputDeviceType, ControllerHand, degToRad } from "flavr-common";
import { Vector3, Quaternion } from "flavr-math";
import { SELECTION_STRATEGY } from "../../../messages/selection";
const LEFT_OCULUS_CONTROLLER_MESH_FILE = "meshes/oculus/oculus_cv1_controller_left_with_buttons";
const RIGHT_OCULUS_CONTROLLER_MESH_FILE = "meshes/oculus/oculus_cv1_controller_right_with_buttons";
function getOculusControllerMeshInfo(rightHand) {
    const sign = rightHand ? -1 : +1;
    return {
        name: rightHand ? "oculus_right" : "oculus_left",
        type: InputDeviceType.OculusController,
        file: rightHand ? RIGHT_OCULUS_CONTROLLER_MESH_FILE : LEFT_OCULUS_CONTROLLER_MESH_FILE,
        side: rightHand ? ControllerHand.RightHand : ControllerHand.LeftHand,
        buttons: [
            {
                index: 0,
                annotation: {
                    anchorPoint: [0.013043 * sign, -0.036362, 0.045943],
                    position: [0.06545 * sign, -0.056083, 0.019642]
                },
                subMeshNames: {
                    pressed: "button_trigger_1",
                    released: "button_trigger_0"
                }
            },
            {
                index: 1,
                annotation: {
                    anchorPoint: [0.01196 * sign, -0.00433, 0.09258],
                    position: [0.051298 * sign, 0.005374, 0.110894]
                },
                subMeshNames: {
                    pressed: "button_grip_1",
                    released: "button_grip_0"
                }
            },
            {
                index: 4,
                annotation: {
                    anchorPoint: [0.015439 * sign, 0.001113, 0.056762],
                    position: [0.079734 * sign, 0.011103, 0.066536]
                },
                subMeshNames: {
                    pressed: rightHand ? "button_A_1" : "button_X_1",
                    released: rightHand ? "button_A_0" : "button_X_0"
                }
            },
            {
                index: 5,
                annotation: {
                    anchorPoint: [0.021686 * sign, -0.007482, 0.046297],
                    position: [0.08143 * sign, -0.00819, 0.044303]
                },
                subMeshNames: {
                    pressed: rightHand ? "button_B_1" : "button_Y_1",
                    released: rightHand ? "button_B_0" : "button_Y_0"
                }
            }
        ],
        invertYAxis: -1,
        recordIndicator: {
            position: new Vector3(0.006821 * sign, -0.00438, 0.052475),
            orientation: new Quaternion().setFromAxisAngle(new Vector3(1, 0, 0), degToRad(-39.422 - 90)),
            scale: new Vector3().setScalar(0.06)
        },
        makerRadar: {
            radius: 0.05,
            position: new Vector3(0, -0.003346, -0.063921),
            markerScale: 0.04
        },
        gripSpace: {
            position: new Vector3(),
            orientation: new Quaternion().setFromAxisAngle(new Vector3(1, 0, 0), degToRad(-45)),
            scale: new Vector3(1, 1, 1)
        },
        selection: {
            strategy: SELECTION_STRATEGY.RAY_SELECT,
            params: {
                max_ray_length: 1000,
                ray_visible: true,
                ray_color: 0x06316d,
                ray_head_length: 0.05,
                ray_head_width: 0.01
            }
        }
    };
}
export const LEFT_OCULUS_CONTROLLER_MESH_INFO = getOculusControllerMeshInfo(false);
export const RIGHT_OCULUS_CONTROLLER_MESH_INFO = getOculusControllerMeshInfo(true);
